<template>
	<app-page>
		<app-heading :title="isNew ? 'New Market' : market.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'markets' }">Cancel</app-button>
				</app-section-actions>
				<input-country
					v-model="market.country"
					label="Country"
					:preferred="['us', 'ca']"
					:errors="errors.country"
				/>
				<input-state
					label="State/Province"
					v-model="market.state"
					required
					:country="market.country"
					:errors="errors.state"
					hint="State/Province of the market"
				/>
				<input-timezone
					v-model="market.timezone"
					label="Timezone"
					:errors="errors.timezone"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
import states from '@/datasources/states'

export default {
	data() {
		return {
			market: {
				timezone: null,
				country: null,
				state: null,
			},
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.market
		},
		isNew() {
			return this.id === 'new'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.market = await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			const request = this.$ravello.request()
				.v(2)
				.to('markets')

			const { name = '' } = (states[this.market.country] || [])
				.find(state => state.abbreviation === this.market.state)
			const payload = {
				name,
				timezone: this.market.timezone,
				country: this.market.country,
				state: this.market.state,
			}

			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request.to(this.id).update(payload)
				}

				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Market successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'markets' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
